import { useRouteLoaderData } from "react-router"
import type { loader } from "../root.tsx"

export const useLang = () => {
  const data = useRouteLoaderData<typeof loader>("root")
  if (!data?.lang) {
    throw new Error("useLang hook error: `lang` is missing from the root loader data")
  }
  return data.lang
}
